<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="关联用户套餐id" prop="projectSetsId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.projectSetsId" placeholder="请填写关联用户套餐id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="排序" prop="sort"
                :rules="[
                 ]">
              <el-input v-model="inputForm.sort" placeholder="请填写排序"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="父id" prop="parentId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.parentId" placeholder="请填写父id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="等级" prop="grade"
                :rules="[
                 ]">
              <el-input v-model="inputForm.grade" placeholder="请填写等级"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="字典id" prop="dictValueId"
                :rules="[
                 ]">
              <el-input v-model="inputForm.dictValueId" placeholder="请填写字典id"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="功能空间ids" prop="functionalSpaceIds"
                :rules="[
                 ]">
              <el-input v-model="inputForm.functionalSpaceIds" placeholder="请填写功能空间ids"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label=" 功能空间ids" prop="functionSpacePositionIds"
                :rules="[
                 ]">
              <el-input v-model="inputForm.functionSpacePositionIds" placeholder="请填写 功能空间ids"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="用户选择的功能空间ids" prop="userSpaceIds"
                :rules="[
                 ]">
              <el-input v-model="inputForm.userSpaceIds" placeholder="请填写用户选择的功能空间ids"     ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmUserSetMealPositionService from '@/api/cecunmusersetmealposition/cecUnmUserSetMealPositionService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          projectSetsId: '',
          sort: '',
          parentId: '',
          grade: '',
          dictValueId: '',
          nameEn: '',
          nameCn: '',
          functionalSpaceIds: '',
          functionSpacePositionIds: '',
          userSpaceIds: ''
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM用户套餐空间关联表`
        } else if (method === 'edit') {
          this.title = '修改UM用户套餐空间关联表'
        } else if (method === 'view') {
          this.title = '查看UM用户套餐空间关联表'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmUserSetMealPositionService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmUserSetMealPositionService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
